import { createAction, props } from '@ngrx/store';
import { PaymentMandateRequest, PaymentMandateResponse } from '../models/payment-mandate.model';

export const loadGeneratePaymentMandates = createAction(
  '[GeneratePaymentMandate] Load GeneratePaymentMandates',
  props<{ request: { businessId: string; body: PaymentMandateRequest } }>()
);

export const loadGeneratePaymentMandatesSuccess = createAction(
  '[GeneratePaymentMandate] Load GeneratePaymentMandates Success',
  props<{ response: PaymentMandateResponse }>()
);

export const loadGeneratePaymentMandatesFailure = createAction(
  '[GeneratePaymentMandate] Load GeneratePaymentMandates Failure',
  props<{ error: Error | any }>()
);

export const clearGeneratePaymentMandatesSuccess = createAction('[GeneratePaymentMandate] Clear GeneratePaymentMandates Success');

//Mock Action for now
export const loadMockCreditCardDetails = createAction(
  '[GeneratePaymentMandate] Load Mock Credit Card Details',
  props<{ data: PaymentMandateRequest }>()
);
